import React from 'react';
import { Popconfirm } from 'antd';
import CapsuleButton from './CapsuleButton';
import DefaultButton from './DefaultButton';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';

/**
 *
 * @returns {삭제 확인 알럿 창}
 */

interface IProps {
  title: string;
  onConfirm: any; //todo 알맞게 적용시키기
  disabled?: boolean;
  children?: any;
  notTable?: boolean; // notTable이 있으면 DefaultButton을 사용한다.(테이블에 쓰는 버튼이 아니라는 것)
  backColor?: string;
  style?: React.CSSProperties;
  LeftPlaceHolder?: JSX.Element;
  hoverColor?: string | null;
}
const DeletePopConfirm = ({
  title,
  onConfirm,
  disabled,
  children,
  notTable,
  backColor,
  style,
  LeftPlaceHolder,
  hoverColor = null,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <Popconfirm disabled={disabled} title={title} onConfirm={onConfirm}>
      {LeftPlaceHolder && LeftPlaceHolder}
      {notTable ? (
        <DefaultButton backColor={theme.colors.del_danger} textColor='#fff'>
          {children
            ? children
            : t('storyEpisodeID.storyTabMenuList.episodeContent.table.delete')}
        </DefaultButton>
      ) : (
        <CapsuleButton
          style={style}
          backColor={backColor ? `${backColor}` : `${theme.colors.del_danger}`}
          disabled={disabled}
          color='#fff'
          hoverColor={hoverColor}
        >
          {children
            ? children
            : t('storyEpisodeID.storyTabMenuList.episodeContent.table.delete')}
        </CapsuleButton>
      )}
    </Popconfirm>
  );
};

export default DeletePopConfirm;
